import React from 'react';

import styled from 'styled-components';

import { COMPANY_STATUS } from 'constants/company';

import CommunityAdminContentCompetitorsNotification from './CommunityAdminContentCompetitorsNotification';
import CommunityAdminContentCompetitorsSearch from './CommunityAdminContentCompetitorsSearch';
import { useCommunityAdminContext } from './CommunityAdminContextProvider';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 520px;
  overflow: hidden;
  border-left: 1px solid var(--line-gray);
`;

const Title = styled.div`
  font-size: 18px;
  font-family: var(--font-bold);
  color: var(--text-primary);
  padding-top: 16px;
  padding-left: 20px;
`;

const CommunityAdminContentCompetitors = () => {
  const { communityId, loadingCommunity, selectedCompany } = useCommunityAdminContext();
  const showCompetitors =
    communityId ||
    [COMPANY_STATUS.IN_TRIAL, COMPANY_STATUS.PAYING_CUSTOMER, COMPANY_STATUS.DEMO].includes(
      selectedCompany?.status || -1
    );

  return (
    <Container>
      {!loadingCommunity && (
        <>
          {showCompetitors && (
            <>
              <Title>Competitors</Title>
              <CommunityAdminContentCompetitorsSearch />
            </>
          )}
          {!showCompetitors && <CommunityAdminContentCompetitorsNotification />}
        </>
      )}
    </Container>
  );
};

export default CommunityAdminContentCompetitors;
